import axios from 'axios';
import { combineReducers } from 'redux';

import * as Urls from 'src/constants/EndpointUrls';

import createNamedWrapperReducer from 'src/reducers/createNamedWrapperReducer';
import { itemReducer } from 'src/reducers/common';
import { setGlobalSuccesses, setGlobalErrors } from 'src/reducers/global';
import { newItem, newItemFailure, editItem, editItemFailure } from 'src/reducers/common/itemReducer';
import { redirectTo, concatParamsToUrl } from 'src/utils/Http';
import { scrollToTop } from 'src/utils/Utils';
import { getBase64 } from "../../utils/Reducer"
import { setList, fetchListSuccess, fetchListFailure } from 'src/reducers/common/listReducer';
import { getTutorialStep1, setTutorialStep1 } from '../../utils/Tutorial';
export const REDUCER_NAME = 'clients';

// Async Action Creators
export const newClient = data => async dispatch => {
  try {
    dispatch(newItem(REDUCER_NAME));
    await axios.post(Urls.CREATE_CLIENT_URL, data);
    redirectTo(Urls.CLIENT_SHOW);
  } catch (exception) {
    dispatch(newItemFailure(REDUCER_NAME, exception.response.data.errors.messages));
  }
};

export const editClient = data => async dispatch => {
  try {
    dispatch(editItem(REDUCER_NAME));
    var logo = await getBase64(data.client.logo)
    var signature = await getBase64(data.client.signature)

    var clientBranch = await Promise.all(data.clientBranch.map(async (clientBranch) => {
      var branchLogo = await getBase64(clientBranch.logo)
      var branchSignature = await getBase64(clientBranch.signature)
      return { ...clientBranch, logo: branchLogo, signature: branchSignature }
    }))

    await axios.put(Urls.UPDATE_CLIENT_URL, {
      ...data,
      client: {
        ...data.client,
        logo: logo,
        signature: signature
      },
      clientBranch: [
        ...clientBranch
      ]
    });
    const tutorialStep1 = getTutorialStep1()
    if (tutorialStep1) {
      const { run, stepIndex, tourCompleted, type } = tutorialStep1
      if (run && stepIndex == 4) {
        setTutorialStep1({ run: true, stepIndex: 0, tourCompleted: false, type: 'show' })
      }
      if (!run)
        setTutorialStep1({ run: false, stepIndex: 0, tourCompleted: true, type: 'next' })

    }

    redirectTo(Urls.CLIENT_SHOW);
  } catch (exception) {
    scrollToTop();
    dispatch(editItemFailure(REDUCER_NAME, exception.response.data.errors.messages));
  }
};

export const newCompany = data => async dispatch => {
  try {
    dispatch(newItem(REDUCER_NAME));

    var logo = _.isUndefined(data.client.logo) ? null : await getBase64(data.client.logo);
    var signature = _.isUndefined(data.client.signature) ? null : await getBase64(data.client.signature);

    if (_.isUndefined(data.clientBranch)) {
      var clientBranch = {};
    } else {
      var clientBranch = await Promise.all(data.clientBranch.map(async (clientBranch) => {
        var branchLogo = await getBase64(clientBranch.logo)
        var branchSignature = await getBase64(clientBranch.signature)
        return { ...clientBranch, logo: branchLogo, signature: branchSignature }
      }))
    }

    const response = await axios.post(Urls.CREATE_COMPANY_URL, {
      ...data,
      client: {
        ...data.client,
        logo: logo,
        signature: signature
      },
      clientBranch: [
        ...clientBranch
      ]
    });
    redirectTo(concatParamsToUrl(Urls.COMPANY_SHOW, { id: response.data.payload.company.id }));
  } catch (exception) {
    scrollToTop();
    dispatch(newItemFailure(REDUCER_NAME, exception.response.data.errors.messages));
  }
};

export const editCompany = data => async dispatch => {
  try {
    dispatch(editItem(REDUCER_NAME));
    const updateUrl = concatParamsToUrl(Urls.COMPANY_UPDATE, { id: data.client.id });
    var logo = await getBase64(data.client.logo);
    var signature = await getBase64(data.client.signature);

    var clientBranch = await Promise.all(data.clientBranch.map(async (clientBranch) => {
      var branchLogo = await getBase64(clientBranch.logo);
      var branchSignature = await getBase64(clientBranch.signature);
      return { ...clientBranch, logo: branchLogo, signature: branchSignature };
    }));

    const response = await axios.put(updateUrl, {
      ...data,
      client: {
        ...data.client,
        logo: logo,
        signature: signature
      },
      clientBranch: [
        ...clientBranch
      ]
    });
    redirectTo(concatParamsToUrl(Urls.COMPANY_SHOW, { id: response.data.payload.company.id }));
  } catch (exception) {
    scrollToTop();
    dispatch(editItemFailure(REDUCER_NAME, exception.response.data.errors.messages));
  }
};

export const deleteCompany = id => async dispatch => {
  try {
    await axios.delete(concatParamsToUrl(Urls.DELETE_COMPANY_URL, { id }));
    redirectTo(Urls.LIST_COMPANY_URL);
  } catch (exception) {
    dispatch(setGlobalErrors(exception.data.errors.messages));
  }
};

export const fetchCompany = () => async dispatch => {
  try {
    const response = await axios.get(Urls.LIST_COMPANY_URL, { params: { timestamp: Date.now() } });
    const payload = { data: response.data.payload.companies };
    await dispatch(setList(REDUCER_NAME, payload));
    await dispatch(fetchListSuccess(REDUCER_NAME, payload));
  } catch (execption) {
    dispatch(fetchListFailure(REDUCER_NAME, exception.response.data.errors.messages));
  }
};

export const updateClientTaxCalMethod = data => async dispatch => {
  try {
    dispatch(editItem(REDUCER_NAME));
    await axios.put(Urls.CLIENT_TAX_CAL_METHOD_SETTING_UPDATE, { client: data });
    dispatch(setGlobalSuccesses('所得税（源泉徴収税額）の計算方法を保存しました。'));
  } catch (exception) {
    dispatch(editItemFailure(REDUCER_NAME, exception.response.data.errors.messages));
  }
};

export const ClientImportLogo = file => async dispatch => {
  const formData = new FormData()
  var image = ''
  try {
    if (file.type.split("/")[0] === "image") {
      formData.append('image', file, file.fileName);
      await axios.post(Urls.IMPORT_CLIENT_LOGO_IMAGE, formData).then((response) => {
        image = response
      })
      dispatch(setGlobalSuccesses('Image uploaded successfully.'));
      return `http://static.payroll.jobcan.in.th/${image.data.imageUrl}`
    }
    else {
      dispatch(setGlobalErrors('This cannot upload any type of files except image. Please upload the image.'));
    }
  } catch (error) {
    dispatch(setGlobalErrors('An error encounted.'));
    // return 'https://pyxis.nymag.com/v1/imgs/09c/923/65324bb3906b6865f904a72f8f8a908541-16-spongebob-explainer.rsquare.w700.jpg'
  }
}

export const ClientImportSign = file => async dispatch => {
  const formData = new FormData()
  var image = ''
  try {
    if (file.type.split("/")[0] === "image") {
      formData.append('image', file, file.fileName);
      await axios.post(Urls.IMPORT_CLIENT_SIGNATURE_IMAGE, formData).then((response) => {
        image = response
      })
      dispatch(setGlobalSuccesses('Image uploaded successfully.'));
      return `http://static.payroll.jobcan.in.th/${image.data.imageUrl}`
    }
    else {
      dispatch(setGlobalErrors('This cannot upload any type of files except image. Please upload the image.'));
    }
  } catch (error) {
    dispatch(setGlobalErrors('An error encounted.'));
    // return 'https://pyxis.nymag.com/v1/imgs/09c/923/65324bb3906b6865f904a72f8f8a908541-16-spongebob-explainer.rsquare.w700.jpg'
  }
}

export default combineReducers({
  item: createNamedWrapperReducer(itemReducer, REDUCER_NAME)
});
